var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", [
                  _vm._v(" Moduły dostępne w systemie dla firmy: "),
                  _c("br"),
                  _c("b", [_vm._v(_vm._s(_vm.companyName))])
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c("v-checkbox", {
                    attrs: {
                      label: "Moduł delegacji",
                      "hide-details": "",
                      "true-value": 2,
                      "false-value": 1
                    },
                    model: {
                      value: _vm.model.is_module_delegation_enabled,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "is_module_delegation_enabled", $$v)
                      },
                      expression: "model.is_module_delegation_enabled"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      label: "Moduł ofertownika",
                      "hide-details": "",
                      "true-value": 2,
                      "false-value": 1
                    },
                    model: {
                      value: _vm.model.is_module_travel_service_enabled,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.model,
                          "is_module_travel_service_enabled",
                          $$v
                        )
                      },
                      expression: "model.is_module_travel_service_enabled"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      label: "Moduł eksportu do Optimy",
                      "hide-details": "",
                      "true-value": 2,
                      "false-value": 1
                    },
                    model: {
                      value: _vm.model.is_module_optima_enabled,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "is_module_optima_enabled", $$v)
                      },
                      expression: "model.is_module_optima_enabled"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      label: "Moduł podglądu wszystkich bookingów",
                      "hide-details": "",
                      "true-value": 2,
                      "false-value": 1
                    },
                    model: {
                      value: _vm.model.is_module_all_bookings_enabled,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.model,
                          "is_module_all_bookings_enabled",
                          $$v
                        )
                      },
                      expression: "model.is_module_all_bookings_enabled"
                    }
                  }),
                  _c("v-checkbox", {
                    attrs: {
                      label: "Moduł podglądu bookingów lotniczych",
                      "hide-details": "",
                      "true-value": 2,
                      "false-value": 1
                    },
                    model: {
                      value: _vm.model.is_module_flight_bookings_enabled,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.model,
                          "is_module_flight_bookings_enabled",
                          $$v
                        )
                      },
                      expression: "model.is_module_flight_bookings_enabled"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("Anuluj")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      on: { click: _vm.save }
                    },
                    [_vm._v("Zapisz")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }